import { isEmpty } from "lodash";
import React from "react";

import ACModalPlacementMenu from "ac-components/ac-modal/ACModalPlacementMenu";
import ACModalV2 from "ac-components/ac-modal/ACModalV2";

import { useAssetsDetails } from "./AssetsDetailsProvider";

export default function AssetsDetailsTitle() {
  const { assetID, assetDetails } = useAssetsDetails();
  const { name } = assetDetails;
  const modalSettings = ACModalV2.useModalSettings();

  if (isEmpty(assetDetails)) {
    return <></>;
  }
  const displayName = `${assetID}${name ? `: ${name}` : ""}`;
  return (
    <div className="d-flex align-items-center justify-content-between">
      <div className="d-flex align-items-center w-100">
        <ACModalPlacementMenu
          currentPlacement={modalSettings.placement}
          onPlacementChange={(placement) =>
            modalSettings.updatePlacement(placement)
          }
        />
        <div className="m-l-xs text-ellipsis" title={displayName}>
          {displayName}
        </div>
      </div>
      <div className="d-flex">
        {/* <ACDropdown items={[]} placement="bottomRight">
          <ACButton type="outline" iconOnly size="md" className="m-l-xs">
            <MenuIcon />
          </ACButton>
        </ACDropdown> */}
      </div>
    </div>
  );
}
